import { TableColumnType } from '@ui';
import { InvoiceStatus } from '@/api/apis/case';

export const INVOICE_TABLE_COLUMNS: TableColumnType[] = [
  {
    key: 'invoice',
    label: 'INVOICE',
    isSortable: false,
    minWidthClassName: 'w-2/3',
  },
  {
    key: 'status',
    label: 'STATUS',
    isSortable: true,
    minWidthClassName: 'w-1/3',
  },
];

export const invoiceStatusOrder: Record<InvoiceStatus, number> = {
  [InvoiceStatus.Open]: 0,
  [InvoiceStatus.PartiallyCredited]: 1,
  [InvoiceStatus.FullyCredited]: 2,
  [InvoiceStatus.PartiallyPaid]: 3,
  [InvoiceStatus.Paid]: 4,
};
